module.exports = "https://trybtryb-legacy.web.app/img/support.3e22ca47.svg";